import type { ReactNode } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import type { CardAppearance } from 'modules/shift_management/components/ShiftManagement/TimeGridTable/types'

const CARD_SLOT_SELECTED_SHADOW = 'inset 0 0 0 2px #2B74FF'

interface Props {
  gridColumn: string
  gridRow: string
  minHeight: number
  paddingX: number
  cardPaddingX: number
  cardPaddingY: number
  radius: number
  appearance?: CardAppearance
  isSelected?: boolean
  onCardSlotSelected?: () => void
  children: ReactNode
}

const GridCard = ({
  gridColumn,
  gridRow,
  minHeight,
  paddingX,
  cardPaddingX,
  cardPaddingY,
  radius,
  appearance,
  isSelected = false,
  onCardSlotSelected,
  children,
}: Props) => {
  // Card slot click: selects the slot, stops propagation to prevent cell selection.
  const handleCardSlotClick = onCardSlotSelected
    ? (event: MouseEvent) => {
        event.stopPropagation()
        onCardSlotSelected()
      }
    : undefined

  // Card click: reserved for future interactions.
  // Stops propagation so clicking the card content does NOT trigger card slot selection.
  const handleCardClick = onCardSlotSelected
    ? (event: MouseEvent) => {
        event.stopPropagation()
      }
    : undefined

  return (
    <Box
      onClick={handleCardSlotClick}
      style={{
        gridColumn,
        gridRow,
        alignSelf: appearance?.fillHeight ? 'stretch' : 'start',
        minHeight: `${String(minHeight)}px`,
        height: appearance?.fillHeight ? 'auto' : undefined,
        padding: '6px',
        boxSizing: 'border-box',
        boxShadow: isSelected ? CARD_SLOT_SELECTED_SHADOW : undefined,
        cursor: onCardSlotSelected ? 'pointer' : undefined,
      }}
    >
      <Box
        background={appearance?.background}
        border={appearance?.border}
        className={appearance?.className}
        onClick={handleCardClick}
        style={{
          opacity: appearance?.opacity,
          margin: `0 ${String(paddingX)}px`,
          padding: `${String(cardPaddingY)}px ${String(cardPaddingX)}px`,
          borderRadius: `${String(radius)}px`,
          boxSizing: 'border-box',
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export { GridCard }
